// Système de tracking automatique des visiteurs
// Ce fichier contient les fonctions utilitaires pour tracker les visiteurs

// Fonction utilitaire pour obtenir l'IP de l'utilisateur (via une API publique)
const getVisitorIP = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    return "Non disponible";
  }
};

// Fonction pour obtenir les informations du navigateur
const getBrowserInfo = () => {
  const ua = navigator.userAgent;
  let browser = "Inconnu";
  let os = "Inconnu";

  // Détection du navigateur
  if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edg") === -1) {
    browser = "Chrome";
  } else if (ua.indexOf("Firefox") > -1) {
    browser = "Firefox";
  } else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1) {
    browser = "Safari";
  } else if (ua.indexOf("Edg") > -1) {
    browser = "Edge";
  }

  // Détection de l'OS
  if (ua.indexOf("Windows") > -1) {
    os = "Windows";
  } else if (ua.indexOf("Mac") > -1) {
    os = "macOS";
  } else if (ua.indexOf("Linux") > -1) {
    os = "Linux";
  } else if (ua.indexOf("Android") > -1) {
    os = "Android";
  } else if (ua.indexOf("iOS") > -1 || ua.indexOf("iPhone") > -1) {
    os = "iOS";
  }

  return { browser, os };
};

// Fonction pour obtenir l'email de l'utilisateur depuis localStorage
const getVisitorEmail = () => {
  // Vérifier d'abord si c'est un admin connecté
  const adminEmail = localStorage.getItem("adminEmail");
  if (adminEmail) {
    return adminEmail;
  }
  // Vérifier s'il y a un email utilisateur stocké
  const userEmail = localStorage.getItem("userEmail");
  if (userEmail) {
    return userEmail;
  }
  // Retourner "Non disponible" si aucun email n'est trouvé
  return "Non disponible";
};

// Fonction pour enregistrer une nouvelle visite
export const recordVisit = async (page = null) => {
  try {
    const visitors = JSON.parse(localStorage.getItem("visitors") || "[]");
    const ip = await getVisitorIP();
    const { browser, os } = getBrowserInfo();
    const currentPage = page || window.location.pathname;
    const screenResolution = `${window.screen.width}x${window.screen.height}`;
    const language = navigator.language || navigator.userLanguage;
    const email = getVisitorEmail();

    const newVisit = {
      id: Date.now(),
      timestamp: new Date().toISOString(),
      date: new Date().toLocaleString("fr-FR"),
      ip: ip,
      email: email,
      browser: browser,
      os: os,
      page: currentPage,
      screenResolution: screenResolution,
      language: language,
      userAgent: navigator.userAgent,
    };

    visitors.unshift(newVisit); // Ajouter au début de la liste

    // Limiter à 1000 visiteurs maximum pour éviter de surcharger le localStorage
    if (visitors.length > 1000) {
      visitors.pop();
    }

    localStorage.setItem("visitors", JSON.stringify(visitors));
    return newVisit;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de la visite:", error);
  }
};

// Fonction pour vérifier et enregistrer une visite si nécessaire
export const checkAndRecordVisit = async (page = null) => {
  const lastVisit = localStorage.getItem("lastVisitTimestamp");
  const lastPage = localStorage.getItem("lastVisitPage");
  const now = Date.now();
  const currentPage = page || window.location.pathname;

  // Enregistrer une nouvelle visite si :
  // - C'est la première visite
  // - Plus de 5 minutes se sont écoulées depuis la dernière visite
  // - L'utilisateur a changé de page
  if (
    !lastVisit ||
    now - parseInt(lastVisit) > 5 * 60 * 1000 ||
    lastPage !== currentPage
  ) {
    await recordVisit(currentPage);
    localStorage.setItem("lastVisitTimestamp", now.toString());
    localStorage.setItem("lastVisitPage", currentPage);
  }
};